import { node } from "~/util/dom";
import ReportFormField from "./index";
import { ICommonOpts } from "~/report/interfaces";

interface IOpts extends ICommonOpts {
	name: string;
	items: Array<{
		value: any;
		label: string;
	}>;
	onChange: (value: string) => void;
}

export default class ReportFormFieldSwitch extends ReportFormField {
	#opts: IOpts;

	constructor(opts: IOpts) {
		super(opts);
		this.#opts = {
			onChange: () => { /**/ },
			...opts,
		};
		this.#build();
	}

	handleEvent(event: Event) {
		if (event.type === "change") {
			const { value } = event.target as HTMLInputElement;

			this.#opts.onChange(value);
		}
	}

	#build() {
		const { parentName, name, items } = this.#opts;

		const switchNode = node("div", { className: "radio" });

		for (let index = 0; index < items.length; index += 1) {
			const item = items[index];
			const { value, label } = item;
			const inputNode = node("input", { type: "radio", name, value });

			inputNode.id = `${parentName}-${name}-${value}`;
			const labelNode = node("label", { innerText: label });

			labelNode.setAttribute("for", inputNode.id);
			switchNode.append(inputNode, labelNode);
			inputNode.addEventListener("change", this);

			if (index === 0) {
				inputNode.checked = true;
				this.#opts.onChange(value);
			}
		}

		super.container.append(switchNode);
	}
}
